
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetotrimkeshwercab() {



    const cardData =
    {
        keyword: 'Pune to Trimbakeshwar Taxi Services',
        heading: 'S9 Travels: Pune to Trimbakeshwar Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Trimbakeshwar. Whether you are traveling for a spiritual visit or to explore the serene surroundings of Trimbakeshwar, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Trimbakeshwar is approximately 185 km from Pune, and the journey takes around 4 to 5 hours by road. Enjoy a safe and comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Trimbakeshwar with S9 Travels',

        "topPlaces": [
            {
              "title": "Trimbakeshwar Temple",
              "description": "The Trimbakeshwar Temple is one of the 12 Jyotirlingas dedicated to Lord Shiva. This revered temple is a major pilgrimage site for devotees who visit to seek blessings and experience the spiritual aura of this sacred place. The temple is known for its unique architecture and the holy river Godavari originating from here."
            },
            {
              "title": "Godavari River",
              "description": "The Godavari River holds significant religious importance, and Trimbakeshwar is the source of this sacred river. Pilgrims visit the town to take a holy dip in the river, which is believed to cleanse the soul. The serene surroundings near the river make it an ideal place for meditation and reflection."
            },
            {
              "title": "Brahmagiri Hill",
              "description": "Brahmagiri Hill is the birthplace of the Godavari River. It offers stunning panoramic views of the surrounding hills and valleys. The trek to the hill is a popular activity for adventure lovers, and reaching the top provides a sense of tranquility and divine connection with nature."
            },
            {
              "title": "Anjneri Hill",
              "description": "Anjneri Hill, located near Trimbakeshwar, is believed to be the birthplace of Lord Hanuman. It is a popular spot for trekkers and devotees. The hill offers a beautiful hiking experience, with views of the lush green landscape and a peaceful environment for spiritual reflection."
            },
            {
              "title": "Nashik",
              "description": "While in Trimbakeshwar, a visit to the nearby city of Nashik is also highly recommended. Nashik is known for its temples, vineyards, and scenic beauty. The famous Pandav Leni caves and the Kalaram Sansthan Temple are must-visit places in Nashik."
            },
            {
              "title": "Ganga Godavari Sangam",
              "description": "The confluence of the rivers Ganga and Godavari is a serene and sacred spot in Trimbakeshwar. Pilgrims visit the Sangam to perform rituals and take a holy dip. It is also a peaceful place for nature lovers to sit and relax while enjoying the view of the flowing rivers."
            },
            {
              "title": "Trimbakeshwar Fort",
              "description": "Trimbakeshwar Fort is an ancient fort that sits atop the Brahmagiri Hill. Though in ruins, it offers great historical significance and panoramic views of the surrounding region. The fort is a great spot for trekkers and history enthusiasts."
            },
            {
              "title": "Kalaram Sansthan Temple",
              "description": "Located in Nashik, not far from Trimbakeshwar, the Kalaram Sansthan Temple is dedicated to Lord Rama. The temple is an important religious site and attracts pilgrims and devotees from all over India. The temple is renowned for its beautiful architecture and peaceful atmosphere."
            },
            {
              "title": "Saptashrungi Temple",
              "description": "Situated around 60 km from Trimbakeshwar, the Saptashrungi Temple is a sacred place dedicated to Goddess Saptashrungi. The temple is perched on a hill, and reaching it involves a scenic trek. The temple offers a stunning view of the surrounding hills and valleys."
            },
            {
              "title": "Vani Temple",
              "description": "The Vani Temple is dedicated to Goddess Renuka, located about 25 km from Trimbakeshwar. It is a peaceful and lesser-known pilgrimage site offering a serene environment and beautiful surroundings. The temple is visited by devotees seeking blessings from the goddess."
            }
          ],

"services": [
  {
    "name": "Pune to Trimbakeshwar Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Trimbakeshwar. Whether you're visiting the sacred Trimbakeshwar Temple or exploring the scenic surroundings, enjoy a smooth and hassle-free ride. Book your Pune to Trimbakeshwar taxi today!"
  },
  {
    "name": "Pune to Trimbakeshwar Cab Booking",
    "description": "Booking a cab from Pune to Trimbakeshwar is easy with S9 Travels. Whether you prefer booking online or by phone, we provide flexible booking options to ensure your journey is comfortable and convenient. Book your ride today!"
  },
  {
    "name": "Pune to Trimbakeshwar Taxi Service",
    "description": "Choose S9 Travels for a reliable and professional taxi service from Pune to Trimbakeshwar. Our experienced drivers and well-maintained vehicles ensure that you have a safe, comfortable, and enjoyable journey every time."
  },
  {
    "name": "Pune to Trimbakeshwar One-Way Taxi",
    "description": "S9 Travels provides affordable one-way taxi services from Pune to Trimbakeshwar. Enjoy a direct, comfortable ride to your destination without any return trip hassles. Book your one-way taxi today for a stress-free experience."
  },
  {
    "name": "Pune to Trimbakeshwar Round Trip",
    "description": "For a round trip from Pune to Trimbakeshwar, S9 Travels offers flexible and reliable options. We ensure a smooth, timely, and comfortable journey, with professional drivers making your round trip enjoyable and convenient."
  },
  {
    "name": "Pune to Trimbakeshwar Cab Fare",
    "description": "S9 Travels provides transparent and affordable taxi fares for your Pune to Trimbakeshwar journey. We guarantee you’ll get the best value for your money with no hidden charges. Contact us for an accurate fare estimate before booking."
  },
  {
    "name": "Pune to Trimbakeshwar Car Rental",
    "description": "Looking to rent a car for your trip from Pune to Trimbakeshwar? S9 Travels offers flexible car rental services that allow you to travel at your own pace. Choose from a variety of vehicles to suit your preferences and needs."
  },
  {
    "name": "Pune to Trimbakeshwar Luxury Taxi",
    "description": "For a luxurious travel experience, S9 Travels offers premium luxury taxi services from Pune to Trimbakeshwar. Enjoy a comfortable, smooth, and stylish ride with extra space and enhanced comfort, making your journey more relaxing."
  }
],


"tableData": [
  ["Book Pune To Trimbakeshwar Taxi", "Book Pune To Trimbakeshwar Cab Booking"],
  ["Book Pune To Trimbakeshwar Taxi Service", "Book Pune To Trimbakeshwar One-Way Taxi"],
  ["Book Pune To Trimbakeshwar Round Trip", "Book Pune To Trimbakeshwar Cab Fare"],
  ["Book Pune To Trimbakeshwar Car Rental", "Book Pune To Trimbakeshwar Luxury Taxi"],
  ["", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important punctuality is when traveling to Trimbakeshwar, especially for a religious visit or a peaceful retreat. Our drivers ensure timely pickups and drop-offs, ensuring that your trip is smooth and on schedule."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We provide a variety of comfortable vehicles for your journey to Trimbakeshwar. Our fleet includes air-conditioned cars with ample seating and luggage space, designed to make your ride as comfortable and enjoyable as possible."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are not only experienced in handling long-distance trips but are also well-versed with the best routes to Trimbakeshwar. Their professionalism ensures that you have a safe and pleasant journey throughout your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Trimbakeshwar trip. We provide a clear breakdown of the costs, with no hidden charges, ensuring full transparency and a hassle-free experience."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Safety is our top priority. Our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring you have a secure and comfortable journey to Trimbakeshwar."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates round-the-clock, so whether you’re planning an early morning trip or a late-night return, we’re always ready to accommodate your needs. Our customer service team is available at all times to assist you."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Trimbakeshwar cab with S9 Travels is simple and convenient. You can book online via our website or app, or contact our customer service team for assistance with personalized reservations."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you’re visiting Trimbakeshwar for religious purposes or leisure, we offer customized travel packages tailored to your preferences. Let us know your requirements, and we will ensure that your trip is memorable and special."
  }
]



















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Trimbakeshwar cab with S9 Travels?',
            answer: 'Booking is easy! You can book online through our website or app, or you can contact our customer service team for assistance with your booking.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, all our drivers are experienced in long-distance travel and know the best routes to Trimbakeshwar, ensuring a smooth and safe journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Trimbakeshwar travel?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars, all well-maintained for comfort and safety during your trip to Trimbakeshwar.',
          },
          {
            question: 'How do I pay for my Pune to Trimbakeshwar cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making the payment process simple and hassle-free.',
          },
          {
            question: 'Can I book a round trip from Pune to Trimbakeshwar?',
            answer: 'Yes, we offer round-trip services. Just provide your return details, and we will ensure a seamless return journey for you.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges, such as for waiting time or detours, will be clearly communicated to you upfront, ensuring full transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Trimbakeshwar?',
            answer: 'Yes, we offer sightseeing services in and around Trimbakeshwar. Visit the famous Trimbakeshwar Temple and explore other local attractions with the guidance of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Trimbakeshwar cab?',
            answer: 'Our vehicles comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us during the booking process, and we’ll make necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Trimbakeshwar?',
            answer: 'Yes, we provide corporate travel services for business visits or group trips between Pune and Trimbakeshwar. We offer professional service to meet the needs of corporate clients.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Trimbakeshwar travel?',
            answer: 'S9 Travels ensures a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We guarantee a safe, stress-free, and enjoyable trip to Trimbakeshwar every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Abhishek Kumar',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip to Trimbakeshwar was excellent, thanks to S9 Travels. The driver was professional, and the vehicle was comfortable and clean. We had a smooth and pleasant journey!”',
        },
        {
          name: 'Mrs. Meera Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made our visit to Trimbakeshwar memorable. The driver was friendly and knowledgeable about the area. The vehicle was spacious, and we had no issues during our trip.”',
        },
      ];
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Trimbakeshwar Cab",
        "description": "Book Pune To Trimbakeshwar taxi services, one-way taxi, round trip, luxury taxi, car rental, and more with S9 Travels. Choose from affordable Pune to Trimbakeshwar cab booking options for a comfortable and safe ride to Trimbakeshwar.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };

      
      


    return (
        <div>
               
      <Helmet>
        <title>Book Pune To Trimbakeshwar Cab | Affordable Taxi & Car Rental Services | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Trimbakeshwar taxi services, one-way taxi, round trip, luxury taxi, car rental, and more with S9 Travels. Get the best fares for Pune to Trimbakeshwar cab booking, ensuring a safe, comfortable, and hassle-free ride." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetotrimkeshwercab;